import { Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'

import { SubmissionsCounters as Counters } from '../utils/helpers/submissions.helpers'

const KEYS: Array<keyof Counters> = ['total', 'pending', 'approved', 'rejected', 'revised']

/**
 * The five counters, straight from the payload — no client-side recount. The
 * fifth needs its sentence: without it "revised" reads as a fifth state instead
 * of a subset of the approved.
 */
const SubmissionsCounters: React.FC<{ counters: Counters }> = ({ counters }) => {
  const { t } = useTranslation()

  return (
    <div className="mb-4">
      <div className="flex flex-wrap gap-2" data-testid="submissions-counters">
        {KEYS.map((key) => (
          <div
            key={key}
            className="rounded-lg border border-gray-300 dark:border-base-gray-600 px-3 py-2 min-w-[7rem]"
            data-testid={`submissions-counter-${key}`}
          >
            <Typography variant="h5" className="leading-none">
              {counters[key]}
            </Typography>
            <Typography variant="small" className="text-gray-600 dark:text-base-gray-500">
              {t(`submissions.counters.${key}`)}
            </Typography>
          </div>
        ))}
      </div>
      <Typography variant="small" className="mt-1 text-gray-600 dark:text-base-gray-500">
        {t('submissions.revisedHelp')}
      </Typography>
    </div>
  )
}

export default SubmissionsCounters
